<div class="upgrade-dialog">
  <button class="close-button" type="button" (click)="matDialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="upgrade-hero">
    <div>
      <div class="growth-badge">
        <mat-icon>workspace_premium</mat-icon>
        Growth
      </div>
      <h2>{{ title }}</h2>
      <p [innerHTML]="body"></p>
    </div>
  </div>

  <div class="benefits">
    <div class="benefit" *ngFor="let benefit of benefits">
      <mat-icon>check_circle</mat-icon>
      <span>{{ benefit }}</span>
    </div>
  </div>

  <div class="actions">
    <button class="secondary-action" type="button" (click)="matDialogRef.close()">
      Not now
    </button>
    <button class="primary-action" type="button" (click)="seePlans()">
      See Growth plans
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
